import { jsx as _jsx } from "react/jsx-runtime";
import { getAvailableItemProfilePages, isEmptyArray } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { useMemberRewards } from '../../hooks/use-member-rewards';
import { ItemPickerList } from './subcomponents/list';
import { ItemPickerMessage, ItemPickerMessageType } from './subcomponents/message';
import { ItemPickerTabs } from './subcomponents/tabs';
import { ItemPickerMode } from './types/config/item-picker-mode';
import { ItemPickerContextInstance } from './types/context';
const b = bemClassBuilder('v-item-picker');
/**
 * The **Item Picker** is a generic subcomponent that can be wrapped for different types of Item Picker components.
 */
export const ItemPicker = observer(props => {
    var _a;
    const { displayText, events, assets, config, cdnOptions } = props;
    const availableItemProfilePages = getAvailableItemProfilePages(props.itemProfilePages);
    const itemProfilePages = ((_a = config.itemProfilePageFilterFn) === null || _a === void 0 ? void 0 : _a.call(config, availableItemProfilePages)) || availableItemProfilePages;
    // Load member rewards to show reward-restricted prices.
    useMemberRewards();
    const context = useMemo(() => {
        return { displayText, events, assets, config, cdnOptions };
    }, [displayText, events, assets, config, cdnOptions]);
    if (isEmptyArray(itemProfilePages)) {
        return (_jsx(ItemPickerMessage, { displayText: displayText, assets: assets, messageType: ItemPickerMessageType.NoItems }));
    }
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(ItemPickerContextInstance.Provider, Object.assign({ value: context }, { children: config.mode === ItemPickerMode.Tabs ? (_jsx(ItemPickerTabs, { itemProfilePages: itemProfilePages })) : (_jsx(ItemPickerList, { itemProfilePages: itemProfilePages })) })) })));
});
ItemPicker.displayName = 'ItemPicker';
